import { IRawSqlDefinitionInput } from '../../../../utils/apollo/graphqlSchema';
import {
  CustomColumnCell,
  CustomDefinitionFormWrapper,
  RawSqlFieldRow,
  StyledRawSqlDefinitionInput,
} from './DerivedColumnEditUI';
import { FieldError, FieldLabel } from '../../../../components/Form';
import React, { useState } from 'react';

interface IProps {
  input: IRawSqlDefinitionInput;
  setInput: (input: IRawSqlDefinitionInput) => void;
  validationError: string | null;
}

const DerivedColumRawSqlEdit = ({
  input,
  setInput,
  validationError,
}: IProps) => {
  const [isDirty, setIsDirty] = useState(false);
  const currentValue = input.rawSql;
  const setCurrentValue = (newValue: string) => {
    setIsDirty(true);
    setInput({
      ...input,
      rawSql: newValue,
    });
  };

  return (
    <CustomDefinitionFormWrapper>
      <CustomColumnCell>
        <FieldLabel>Enter SQL (use @column to reference columns)</FieldLabel>
        <RawSqlFieldRow>
          <StyledRawSqlDefinitionInput
            autoComplete="off"
            name="search"
            value={currentValue}
            onChange={setCurrentValue}
            placeholder={'Enter SQL Expression'}
            hasError={isDirty && !!validationError}
          />
        </RawSqlFieldRow>
        {isDirty && !!validationError && (
          <RawSqlFieldRow>
            <FieldError type={'custom'} customError={validationError} />
          </RawSqlFieldRow>
        )}
      </CustomColumnCell>
    </CustomDefinitionFormWrapper>
  );
};

export default DerivedColumRawSqlEdit;
